import { ReactNode } from 'react';
import { useSecretsQuery } from '../../hooks/useSecretsQuery';
import {
  useHasLoadedSecretsOnce,
  useHydrationStatus,
} from '../../stores/secretsStore';
import { useAuth } from '../../contexts/auth';

type SecretsProviderProps = {
  children: ReactNode;
};

const SecretsProvider = ({ children }: SecretsProviderProps) => {
  const query = useSecretsQuery();
  const hydrationStatus = useHydrationStatus();
  const hasLoadedOnce = useHasLoadedSecretsOnce();
  const { isLoading: isAuthenticating } = useAuth() ?? {};

  if (hydrationStatus.state === 'pending') return null;

  if (query.isError && !hasLoadedOnce) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black text-white">
        <div className="max-w-md p-6 text-center">
          <h1 className="mb-2 text-xl font-semibold">
            Couldn&apos;t load app config
          </h1>
          <p className="mb-4 text-sm opacity-80">
            {query.error instanceof Error
              ? query.error.message
              : 'Unable to reach the secrets service.'}
          </p>
          <button
            type="button"
            onClick={() => query.refetch()}
            className="rounded border border-white px-4 py-2 text-sm hover:bg-white hover:text-black"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (isAuthenticating || !hasLoadedOnce) {
    return <div className="fixed inset-0 z-[9999] bg-black" />;
  }

  return <>{children}</>;
};

export default SecretsProvider;
